import Logger from "../../../../../clients/logger";
export class ObjectPool<T = any> {
	objects: Record<string, T>;

	poolName: string;

	constructor(name: string) {
		this.objects = {};
		this.poolName = name;
	}

	get(name: string, throwError: boolean = true): T {
		let result;
		if (!this.objects.hasOwnProperty(name)) {
			if (throwError && name) {
				Logger.system.debug(`${this.poolName} pool.get failed for ${name}`);
			}
		} else {
			result = this.objects[name];
		}
		return result;
	}

	remove(name: string, throwError: boolean = true): void {
		Logger.system.debug(`${this.poolName} pool.remove for ${name}`);
		if (throwError && !this.objects.hasOwnProperty(name)) {
			Logger.system.debug(`${this.poolName} pool.remove operating on non-existent value for ${name}`);
		}

		delete this.objects[name];
	}

	add(name: string, obj: T): void {
		Logger.system.debug(`${this.poolName} pool.add for ${name}`);
		if (this.objects.hasOwnProperty(name)) {
			Logger.system.debug(`${this.poolName} pool.add overwriting existing value for ${name}`);
		}

		this.objects[name] = obj;
	}

	*iterator() {
		for (const name in this.objects) {
			const obj = this.get(name);
			yield obj;
		}
	}

	getAll() {
		return this.objects;
	}
}
